module.exports = __webpack_public_path__ + "img/icon_quadrangle.b1234c66.ad2a598c.svg";